export const REPORTING = 'REPORTING'
export const REPORTING_SHOW = 'REPORTING_SHOW'

export default {
    list: REPORTING,
    show: REPORTING_SHOW
}
